import { createAction, props } from '@ngrx/store';
import { IChatBotResponse } from '../../../interfaces/chatbot/response/IChatBotResponse';
import { IChatConversationListResponse } from '../../../interfaces/chatbot/response/IChatConversationListResponse';
import { IChatHistoryResponse } from '../../../interfaces/chatbot/response/IChatHistoryResponse';

export const setProjectContext = createAction(
  '[ChatBot] Set Project Context',
  props<{ projectUuid: string }>(),
);

export const loadConversations = createAction('[ChatBot] Load Conversations');

export const loadConversationsSuccess = createAction(
  '[ChatBot] Load Conversations Success',
  props<{ response: IChatConversationListResponse }>(),
);

export const loadConversationsFailure = createAction(
  '[ChatBot] Load Conversations Failure',
  props<{ error: string }>(),
);

export const loadMoreConversations = createAction(
  '[ChatBot] Load More Conversations',
);

export const loadMoreConversationsSuccess = createAction(
  '[ChatBot] Load More Conversations Success',
  props<{ response: IChatConversationListResponse }>(),
);

export const loadMoreConversationsFailure = createAction(
  '[ChatBot] Load More Conversations Failure',
  props<{ error: string }>(),
);

export const loadArchivedConversations = createAction('[ChatBot] Load Archived Conversations');
export const loadArchivedConversationsSuccess = createAction(
  '[ChatBot] Load Archived Conversations Success',
  props<{ response: IChatConversationListResponse }>(),
);
export const loadArchivedConversationsFailure = createAction(
  '[ChatBot] Load Archived Conversations Failure',
  props<{ error: string }>(),
);
export const loadMoreArchivedConversations = createAction('[ChatBot] Load More Archived Conversations');
export const loadMoreArchivedConversationsSuccess = createAction(
  '[ChatBot] Load More Archived Conversations Success',
  props<{ response: IChatConversationListResponse }>(),
);
export const loadMoreArchivedConversationsFailure = createAction(
  '[ChatBot] Load More Archived Conversations Failure',
  props<{ error: string }>(),
);

export const setChatArchived = createAction(
  '[ChatBot] Set Chat Archived',
  props<{ chatUuid: string; archived: boolean }>(),
);
export const setChatArchivedSuccess = createAction(
  '[ChatBot] Set Chat Archived Success',
  props<{ chatUuid: string; archived: boolean; wasActive?: boolean }>(),
);
export const setChatArchivedFailure = createAction(
  '[ChatBot] Set Chat Archived Failure',
  props<{ chatUuid: string; error: string }>(),
);
export const deleteConversation = createAction(
  '[ChatBot] Delete Conversation',
  props<{ chatUuid: string }>(),
);
export const deleteConversationSuccess = createAction(
  '[ChatBot] Delete Conversation Success',
  props<{ chatUuid: string; wasActive?: boolean }>(),
);
export const deleteConversationFailure = createAction(
  '[ChatBot] Delete Conversation Failure',
  props<{ chatUuid: string; error: string }>(),
);

export const openConversation = createAction(
  '[ChatBot] Open Conversation',
  props<{ chatUuid: string }>(),
);

export const openConversationSuccess = createAction(
  '[ChatBot] Open Conversation Success',
  props<{ response: IChatHistoryResponse }>(),
);

export const openConversationFailure = createAction(
  '[ChatBot] Open Conversation Failure',
  props<{ chatUuid: string; error: string }>(),
);

export const startNewConversation = createAction(
  '[ChatBot] Start New Conversation',
);

export const sendPrompt = createAction(
  '[ChatBot] Send Prompt',
  ({ prompt }: { prompt: string }) => ({
    prompt,
    clientMessageId: crypto.randomUUID(),
    createdAt: new Date().toISOString(),
  }),
);

export const sendPromptSuccess = createAction(
  '[ChatBot] Send Prompt Success',
  props<{
    response: IChatBotResponse;
    clientMessageId: string;
    assistantClientMessageId: string;
    completedAt: string;
  }>(),
);

export const sendPromptFailure = createAction(
  '[ChatBot] Send Prompt Failure',
  props<{ clientMessageId: string; error: string }>(),
);

export const setChatLayerVisibility = createAction(
  '[ChatBot] Set Chat Layer Visibility',
  props<{ layerUuid: string; visible: boolean }>(),
);

export const setChatLayerVisibilitySuccess = createAction(
  '[ChatBot] Set Chat Layer Visibility Success',
  props<{ layerUuid: string; visible: boolean }>(),
);

export const setChatLayerVisibilityFailure = createAction(
  '[ChatBot] Set Chat Layer Visibility Failure',
  props<{ layerUuid: string; visible: boolean; error: string }>(),
);

export const setChatLayerActiveSource = createAction(
  '[ChatBot] Set Chat Layer Active Source',
  props<{ layerUuid: string; sourceUuid: string }>(),
);

export const setChatLayerActiveSourceSuccess = createAction(
  '[ChatBot] Set Chat Layer Active Source Success',
  props<{ layerUuid: string; sourceUuid: string }>(),
);

export const setChatLayerActiveSourceFailure = createAction(
  '[ChatBot] Set Chat Layer Active Source Failure',
  props<{ layerUuid: string; sourceUuid: string; error: string }>(),
);

export const zoomToChatLayer = createAction(
  '[ChatBot] Zoom To Chat Layer',
  props<{ layerUuid: string }>(),
);

export const zoomToChatLayerSuccess = createAction(
  '[ChatBot] Zoom To Chat Layer Success',
  props<{ layerUuid: string }>(),
);

export const zoomToChatLayerFailure = createAction(
  '[ChatBot] Zoom To Chat Layer Failure',
  props<{ layerUuid: string; error: string }>(),
);

export const deleteChatLayer = createAction(
  '[ChatBot] Delete Chat Layer',
  props<{ layerUuid: string }>(),
);

export const deleteChatLayerSuccess = createAction(
  '[ChatBot] Delete Chat Layer Success',
  props<{ chatUuid: string; layerUuid: string }>(),
);

export const deleteChatLayerFailure = createAction(
  '[ChatBot] Delete Chat Layer Failure',
  props<{ chatUuid: string; layerUuid: string; error: string }>(),
);

export const resetChatbot = createAction('[ChatBot] Reset');
